import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"

export const downloadFormat = z.union([z.literal("exr"), z.literal("jpg"), z.literal("tiles")])

const descriptorOrChannels = z
    .object({
        channels: z.number(),
    })
    .or(
        z.object({
            descriptor: descriptorDefinition.optional(),
        }),
    )

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z
            .object({
                dataObjectId: z.string(),
                downloadFormat: downloadFormat,
            })
            .and(descriptorOrChannels),
    },
}
